import { FaHeart, FaRegHeart } from "react-icons/fa6";
import { ReactElement } from "react";
import { HotelResult } from "@agent/pages/new-booking/SearchResults";
import { useWishList } from "@agent/context/wish-list";

interface Props {
  result: HotelResult;
}

export function WishListIcon({ result }: Props): ReactElement {
  const { isInWishList, addToWishList, removeFromWishList } = useWishList();

  const wished = isInWishList(result);

  return (
    <div className="cursor-pointer">
      {wished ? (
        <span
          className="text-red-500 hover:text-red-300"
          onClick={() => removeFromWishList(result)}
        >
          <FaHeart />
        </span>
      ) : (
        <span
          className="text-gray-300 hover:text-red-700"
          onClick={() => addToWishList(result)}
        >
          <FaRegHeart />
        </span>
      )}
    </div>
  );
}
